import { z } from "zod";
import passwordStrength from "@/core/utils/password-validation";

// Single source of truth for password strength/complexity. Reused anywhere a
// new password is entered (first-time password set, password reset, etc.).
export const passwordComplexitySchema = z
  .string()
  .refine((pw) => passwordStrength(pw), {
    message: "password.rules",
  });

// Base shape for "new password + confirmation" forms. Composable so other
// schemas (e.g. pw-reset) can extend it with extra fields instead of
// re-declaring the password rules.
export const passwordBaseSchema = z.object({
  password: passwordComplexitySchema,
  password_confirmation: z.string().min(1, "password.required"),
});

// Reusable cross-field check that the two password entries match. Kept
// separate so it can be applied after extending passwordBaseSchema. Applied
// as `.refine(passwordsMatch, passwordsMatchError)`.
export const passwordsMatch = ({
  password,
  password_confirmation,
}: {
  password: string;
  password_confirmation: string;
}) => password === password_confirmation;

export const passwordsMatchError = {
  message: "password_confirmation.invalid",
  path: ["password_confirmation"],
};

// Schema for form validation (includes passwordConfirmation)
export const passwordSchema = passwordBaseSchema.refine(
  passwordsMatch,
  passwordsMatchError,
);

// const storePasswordSchema = passwordBaseSchema.omit({
// 	password_confirmation: true,
// });

export type PasswordData = z.infer<typeof passwordSchema>;
